<div [class.block-loader]="currentImportLoader.isLoading">
	<div class="modal-header">
		<h2 translate="Import.Creation.Synthesis.Labels.Report"></h2>
		<button type="button" data-cy="ModalClose" class="modal-button-close far fa-times" (click)="dismiss.emit()"></button>
	</div>

	<div class="content-block-negative"
		 [class.block-loader]="listLoader.isLoading">
		<import-report-errors-list-table
			[currentImport]="currentImport"
			[actions]="actions" [selectors]="selectors"
			[list]="list$ | async"
		/>
	</div>

	<div class="form-actions form-actions-spaced">
		<button type="submit"
				ngbAutofocus
				class="btn btn-primary"
				(click)="download.emit()"><i
			class="far fa-arrow-to-bottom"></i>&nbsp;&nbsp;{{ ('Actions.Download' | translate) }}</button>
	</div>
</div>
